import { AppRouteNames } from "@/shared/@types";

const StartView = () =>
  import("@/app/gas-shop-app/start/StartView/StartView.vue");
const FavoritesView = () =>
  import("@/app/gas-shop-app/favorites/FavoritesView/FavoritesView.vue");
const QuickOrderView = () =>
  import("@/app/gas-shop-app/quick-order/QuickOrderView/QuickOrderView.vue");
const OrdersView = () =>
  import("@/app/gas-shop-app/orders/OrdersView/OrdersView.vue");
const BottleInventoryView = () =>
  import(
    "@/app/gas-shop-app/bottle-inventory/BottleInventoryView/BottleInventoryView.vue"
  );
const ReturnView = () =>
  import("@/app/gas-shop-app/return/ReturnView/ReturnView.vue");
const RefrigerantManagementView = () =>
  import(
    "@/app/gas-shop-app/refrigerant-management/RefrigerantManagementView/RefrigerantManagementView.vue"
  );
const DeliveryAddressesView = () =>
  import(
    "@/app/gas-shop-app/delivery-addresses/DeliveryAddressesView/DeliveryAddressesView.vue"
  );
const ProductCatalogView = () =>
  import(
    "@/app/gas-shop-app/product-catalog/ProductCatalogView/ProductCatalogView.vue"
  );
const PageNotFoundView = () =>
  import("@/shared/views/PageNotFoundView/PageNotFoundView.vue");

export const routes = [
  {
    path: "",
    redirect: { name: AppRouteNames.GasShopStart },
  },
  {
    path: "start",
    name: AppRouteNames.GasShopStart,
    meta: {
      titleKey: "gasShop.start.title",
    },
    component: StartView,
  },
  {
    path: "favorites",
    name: AppRouteNames.GasShopFavorites,
    meta: {
      titleKey: "gasShop.favorites.title",
    },
    component: FavoritesView,
  },
  {
    path: "quick-order",
    name: AppRouteNames.GasShopQuickOrder,
    meta: {
      titleKey: "gasShop.quickOrder.title",
    },
    component: QuickOrderView,
  },
  {
    path: "orders",
    name: AppRouteNames.GasShopOrders,
    meta: {
      titleKey: "gasShop.orders.title",
    },
    component: OrdersView,
  },
  {
    path: "bottle-inventory",
    name: AppRouteNames.GasShopBottleInventory,
    meta: {
      titleKey: "gasShop.bottleInventory.title",
    },
    component: BottleInventoryView,
  },
  {
    path: "return",
    name: AppRouteNames.GasShopReturn,
    meta: {
      titleKey: "gasShop.return.title",
    },
    component: ReturnView,
  },
  {
    path: "refrigerant-management",
    name: AppRouteNames.GasShopRefrigerantManagement,
    meta: {
      titleKey: "gasShop.refrigerantManagement.title",
    },
    component: RefrigerantManagementView,
  },
  {
    path: "delivery-addresses",
    name: AppRouteNames.GasShopDeliveryAddresses,
    meta: {
      titleKey: "gasShop.deliveryAddresses.title",
    },
    component: DeliveryAddressesView,
  },
  {
    path: "product-catalog",
    name: AppRouteNames.GasShopProductCatalog,
    meta: {
      titleKey: "gasShop.product.catalog.title",
    },
    component: ProductCatalogView,
  },
  {
    path: ":pathMatch(.*)*",
    name: AppRouteNames.FbsHubNotFound,
    meta: {
      titleKey: "shared.error.page.notFoundError.title",
    },
    component: PageNotFoundView,
    props: {
      homeRouteName: AppRouteNames.FbsHubStart,
    },
  },
];
